export default {"src":"/_next/static/media/IconArrowRight.0517adde.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};